import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder
import './About.css'; // Import the Premiumservices.css file
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaTiktok, FaPinterest } from 'react-icons/fa'; // Importing social media icons

import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.

function FollowUsOnSocial() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">stay connected with us</h1>
            <p className="banner-description">
              Follow us on our social channels and never miss an update. Engage with us through the platforms below.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/About Us Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      <section className="about-section">
        {/* Section 1: Social Media Links */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>connect with us, stay in the loop</strong></h2>
            <p>Stay up-to-date with our latest activities and news. Connect with us on social media!</p>
            <div className="social-icons">
  <a href="https://www.facebook.com/shigjeta.agency" target="_blank" rel="noopener noreferrer">
    <FaFacebook size={40} />
  </a>
  <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
    <FaTwitter size={40} />
  </a>
  <a href="https://www.instagram.com/shigjetallc" target="_blank" rel="noopener noreferrer">
    <FaInstagram size={40} />
  </a>
  <a href="https://www.linkedin.com/company/shigjeta" target="_blank" rel="noopener noreferrer">
    <FaLinkedin size={40} />
  </a>
  <a href="https://www.tiktok.com/@shigjetallc" target="_blank" rel="noopener noreferrer">
    <FaTiktok size={40} />
  </a>
  <a href="https://www.pinterest.com/shigjetallc" target="_blank" rel="noopener noreferrer">
    <FaPinterest size={40} />
  </a>
</div>
            <button className="cta-button">Join Us on Social Media</button>
          </div>
          <div className="about-image">
            <img src="/img/as4.1.png" alt="Social Interaction" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default FollowUsOnSocial;
